import React from "react";
import { Button, Grid2 as Grid, Grid2Props, IconButton } from "@mui/material";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import FormLabel from "../../../../components/forms/common/base/FormLabel";
import { useFormHandlerContext } from "../../../../controllers/formController";
import ArraySubFormList from "../../../../components/forms/fields/subForms/array/ArraySubFormList";
import FormTextField from "../../../../components/forms/fields/basic/TextField";
import ArraySubFormProvider from "../../../../components/forms/fields/subForms/array/ArraySubFormProvider";
import ArraySubFormAdd from "../../../../components/forms/fields/subForms/array/ArraySubFormAdd";
import { singleGridItem } from "../../../../components/forms/fields/defaultStyles";
import GroupGridContainer from "../../../../components/common/GroupGridContainer";
import TitleEvidence from "./TitleEvidence";

interface TitleListProps extends Grid2Props {
  name: string;
  label: string;
  rowLabel: string;
  disabled?: boolean;
}

const TitleList: React.FC<TitleListProps> = ({
  name,
  label,
  rowLabel,
  disabled = false,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();

  return (
    <Grid container spacing={1} {...singleGridItem} {...grid}>
      <FormLabel label={label} name={name} />
      <ArraySubFormProvider name={name}>
        <ArraySubFormList
          renderItem={(index, remove) => (
            <GroupGridContainer key={index}>
              <Grid {...singleGridItem}>
                <FormLabel
                  sx={{ fontSize: "1.2rem" }}
                  label={`${rowLabel} ${index + 1}`}
                  actions={
                    <IconButton
                      color="error"
                      onClick={() => remove()}
                      size="small"
                      disabled={disabled || isProcessing}
                    >
                      <RemoveCircleOutline />
                    </IconButton>
                  }
                />
              </Grid>
              <FormTextField
                name="title"
                label="Title"
                placeholder="Enter title"
                required
                disabled={disabled || isProcessing}
              />
              <TitleEvidence
                name="evidences"
                label="Evidences"
                rowLabel="Evidence"
                disabled={disabled || isProcessing}
              />
            </GroupGridContainer>
          )}
        />
        <Grid {...singleGridItem}>
          <ArraySubFormAdd
            render={(append) => (
              <Button
                variant="contained"
                fullWidth
                color="primary"
                startIcon={<AddCircleOutline />}
                disabled={disabled || isProcessing}
                onClick={() =>
                  append({
                    title: "",
                    evidences: [],
                  })
                }
              >
                Add {rowLabel}
              </Button>
            )}
          />
        </Grid>
      </ArraySubFormProvider>
    </Grid>
  );
};
export default TitleList;
